import React from "react";

export const TableIcon = ({ size, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M448 32C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H448zM232 264V160H48V264H232zM48 312V416C48 424.8 55.16 432 64 432H232V312H48zM280 432H448C456.8 432 464 424.8 464 416V312H280V432zM464 264V160H280V264H464z"
      />
    </svg>
  );
};
